// This file was auto-generated by Fern from our API Definition.
/** How this deployment would register itself with the discovered issuer. */
export const McpProbeRegistration = {
    Dynamic: "dynamic",
    Metadata: "metadata",
    Unavailable: "unavailable",
};
